import {
  Button,
  ButtonVariant,
  ButtonSize,
  InputSize,
  Select
} from "shared/components";
import { DateInput, BaseInput } from "shared/components/forms";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  Call02Icon,
  MoreHorizontalIcon,
  ManIcon,
  Mail02Icon
} from "@hugeicons-pro/core-stroke-rounded";

interface CommunicationMetadataProps {
  communicationType: string;
  onTypeChange: (value: string) => void;
  communicationDate: string;
  onDateChange: (value: string) => void;
  communicationTime: string;
  onTimeChange: (value: string) => void;
  onSubmit: () => void;
  isLoading?: boolean;
}

const communicationTypeOptions = [
  {
    value: "Call",
    label: (
      <div className="flex items-center gap-3 text-base font-medium text-content-1000">
        <HugeiconsIcon icon={Call02Icon} size={20} />
        <span>Call</span>
      </div>
    )
  },
  {
    value: "Walk-in",
    label: (
      <div className="flex items-center gap-3 text-base font-medium text-content-1000">
        <HugeiconsIcon icon={ManIcon} size={20} />
        <span>Walk-in</span>
      </div>
    )
  },
  {
    value: "Email",
    label: (
      <div className="flex items-center gap-3 text-base font-medium text-content-1000">
        <HugeiconsIcon icon={Mail02Icon} size={20} />
        <span>Email</span>
      </div>
    )
  },
  {
    value: "Other",
    label: (
      <div className="flex items-center gap-3 text-base font-medium text-content-1000">
        <HugeiconsIcon icon={MoreHorizontalIcon} size={20} />
        <span>Other</span>
      </div>
    )
  }
];

export const CommunicationMetadata = ({
  communicationType,
  onTypeChange,
  communicationDate,
  onDateChange,
  communicationTime,
  onTimeChange,
  onSubmit,
  isLoading = false
}: CommunicationMetadataProps) => {
  return (
    <div className="w-full flex justify-between pt-4">
      <div className="w-[80%] flex flex-wrap items-center gap-6">
        <div className="flex items-center gap-2">
          <label
            htmlFor="communication-type"
            className="text-base font-medium text-content-300"
          >
            Type
          </label>
          <Select
            id="communication-type"
            size={InputSize.SM}
            value={communicationType}
            onChange={(e) => onTypeChange(e.target.value)}
            options={communicationTypeOptions}
            hideOptional
            className="min-w-[121px]"
            legacyErrorMargins={false}
            menuPlacement="top"
          />
        </div>

        <div className="flex items-center gap-2 max-w-[350px]">
          <label
            htmlFor="communication-date"
            className="text-base font-medium text-content-300"
          >
            Date
          </label>
          <DateInput
            id="communication-date"
            size={InputSize.SM}
            value={communicationDate}
            onChange={(e) => onDateChange(e.target.value)}
            hideOptional
            legacyErrorMargins={false}
            menuPlacement="top"
          />
        </div>

        <div className="flex items-center gap-2">
          <label
            htmlFor="communication-time"
            className="text-base font-medium text-content-300"
          >
            Time
          </label>
          <BaseInput
            id="communication-time"
            type="time"
            size={InputSize.SM}
            value={communicationTime}
            onChange={(value) => onTimeChange(value)}
            className="min-w-[121px]"
          />
        </div>
      </div>

      <Button
        variant={ButtonVariant.PRIMARY}
        size={ButtonSize.SM}
        onClick={onSubmit}
        disabled={isLoading}
        loading={isLoading}
        className="ml-auto"
      >
        Record communication
      </Button>
    </div>
  );
};
